<template>
    <div class="skeleton-list">
        <!-- Skeleton Card 1 -->
        <div class="skeleton-card">
        <div class="skeleton-img"></div>
        <div class="skeleton-info">
            <div class="skeleton-line medium"></div>
            <div class="skeleton-line short"></div>
        </div>
        </div>

        <!-- Skeleton Card 2 -->
        <div class="skeleton-card">
        <div class="skeleton-img"></div>
        <div class="skeleton-info">
            <div class="skeleton-line medium"></div>
            <div class="skeleton-line short"></div>
        </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.skeleton-card {
    display: flex;
    flex-direction: column;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 16px;
    width: 100%;
    max-width: 500px;
    background-color: #fff;
  }

  .skeleton-img {
    height: 200px;
    background-color: #e0e0e0;
    animation: pulse 1.5s infinite ease-in-out;
  }

  .skeleton-info {
    padding: 16px;
  }

  .skeleton-line {
    height: 16px;
    margin-bottom: 8px;
    background-color: #e0e0e0;
    border-radius: 4px;
    animation: pulse 1.5s infinite ease-in-out;
  }

  .skeleton-line.short {
    width: 60%;
  }

  .skeleton-line.medium {
    width: 80%;
  }

  .skeleton-line.long {
    width: 100%;
  }

  @keyframes pulse {
    0% {
      background-color: #e0e0e0;
    }
    50% {
      background-color: #f0f0f0;
    }
    100% {
      background-color: #e0e0e0;
    }
  }

  .skeleton-list {
    display: flex;
    flex-direction: column;
    padding-block: 12px;
    max-width: 520px;
    margin: auto;
  }
</style>